define('Search/SearchActiveFiltersSelection',["Search/Search", "jquery", "eventManager", "mustache"],
    function (Search, $, eventManager, mustache) {
        function SearchActiveFiltersSelection(searchFiltersSelectionId) {
			var filterRefinements = {};
			var attributes = ["_industry_hierarchy.Industry", "_industry_hierarchy.SubIndustry", "_resource_type"];
			var $container = $('#'+searchFiltersSelectionId);			

            eventManager.subscribe("SearchFiltersUpdated",
                function () {
                    filterRefinements = Search.search.helper.state.facetsRefinements;
					var html = '<ul class="search-filters-selection-list">';
					
					Object.keys(filterRefinements).map(function (key) { 
						if ($.inArray(key, attributes) > -1) {
							$(filterRefinements[key]).each(function( index ) {
								var rawValue = filterRefinements[key][index];
								var displayValue = rawValue.indexOf('>') > -1 ? rawValue.substring(rawValue.indexOf('>') + 2) : rawValue;
								var item = {
									displayValue: displayValue,
									rawValue: rawValue,
									facetName: key
								};
								html += mustache.render('<li class="search-filters-selection-list-item" data-raw-value="{{rawValue}}" data-facet-name="{{facetName}}">{{displayValue}}<span class="close"></span></li>', item);
							});								
						}									
					});						
					
					html += '</ul>';
					
					$container.html(html);					                    
					
					$('.search-filters-selection-list-item').on('click', function (e) {				
						var data = {
							value: $(this).data('raw-value'),
							facetName: $(this).data('facet-name')					
						};		
						
						eventManager.trigger("ToggleSearchFilter", data);
					});					
                });	

				function facetCollapse() {
				  $('.btn-filter').on('click', function(e) {
					e.preventDefault();
				  });
				  $('.score-left').off('click');
				  if ($(window).width() < 992) {
					$('.score-left').on('click', '.btn-filter', function(){
					  $(this).next('.search-filters').slideToggle();
					});
				  }
				};

				facetCollapse();				
        }

        return function InitActiveSearchFiltersSelection(args) {
            return new SearchActiveFiltersSelection(args.SearchFiltersSelectionId);
        };
    });
